import config from '@/utils/config';
/* eslint-disable quote-props */

const { isModeSollers } = config.workMode;

export default {
  'users': (interfaces) => interfaces.read || interfaces.security,
  'service': (interfaces) => interfaces.read || interfaces.security,
  'suppliers': (interfaces) => interfaces.business && interfaces.read,
  'supplier/:asdb?': (interfaces) => interfaces.read || interfaces.security || interfaces.consolidator,
  'supplier-contacts': (interfaces) => interfaces.business && interfaces.read,
  'orders/order-groups': (interfaces) => interfaces.read,
  'orders/order-groups/:id': (interfaces) => interfaces.read,
  'orders/nearest-shipment': (interfaces) => interfaces.read,
  'orders/nearest-shipment-by-supplier': (interfaces) => interfaces.business && interfaces.read,
  'orders/reports-by-part': (interfaces) => interfaces.read,
  'orders/reports-by-parts': (interfaces) => interfaces.read,
  'orders/history-by-days': (interfaces) => interfaces.read,
  'orders/history-by-weeks': (interfaces) => interfaces.read,
  'orders/promises': (interfaces) => interfaces.read,
  'reports/transactions': (interfaces) => interfaces.business && interfaces.read,
  'reports/balance': (interfaces) => interfaces.business && interfaces.read,
  'reports/turnover': (interfaces) => interfaces.business && interfaces.read,
  'reports/forecast': (interfaces) => interfaces.business && interfaces.read,
  'reports/parts-properties': (interfaces) => interfaces.business && interfaces.read,
  'reports/parts-prices': (interfaces) => interfaces.read,
  'reports/parts-new': (interfaces) => interfaces.read,
  'reports/parts-missing': (interfaces) => interfaces.business && interfaces.read,
  'bulletins/board': (interfaces) => interfaces.read || interfaces.security || interfaces.consolidator,
  'bulletins/board/:id': (interfaces) => interfaces.read || interfaces.security || interfaces.consolidator,
  'bulletins/list': (interfaces) => interfaces.business && interfaces.editor,
  'bulletins/list/create': (interfaces) => interfaces.business && interfaces.editor,
  'emails/list': (interfaces) => interfaces.business || interfaces.read,
  'emails/list/:id': (interfaces) => interfaces.business || interfaces.read,
  'emails/templates': (interfaces) => interfaces.business && interfaces.read,
  'emails/templates/:name': (interfaces) => interfaces.business && interfaces.read,
  'roles': (interfaces) => interfaces.business && interfaces.security,
  'aftersales-orders': (interfaces) => interfaces.read,
  'aftersales-orders/sales-report': (interfaces) => isModeSollers && interfaces.read,
  'aftersales-orders/:number': (interfaces) => interfaces.read,
  'asn': (interfaces) => interfaces.read || interfaces.consolidator,
  'asn/create': (interfaces) => interfaces.full || (interfaces.supplier && interfaces.editor) || interfaces.consolidator,
  'asn/:id': (interfaces) => interfaces.read || interfaces.consolidator,
  'asn/:id/track-statuses': (interfaces) => interfaces.read || interfaces.consolidator,
  'asn/:id/customs-statuses': (interfaces) => interfaces.read || interfaces.consolidator,
  'asn/:id/system-statuses': (interfaces) => interfaces.read || interfaces.consolidator,
  'labels/print': (interfaces) => interfaces.read || interfaces.consolidator,
  'labels/templates': (interfaces) => interfaces.business && (interfaces.read || interfaces.editor),
  'files': (interfaces) => interfaces.business && (interfaces.read || interfaces.security),
  'consolidator/asn-list': (interfaces) => interfaces.full || interfaces.consolidator,
  'consolidator/asn-receiving': (interfaces) => interfaces.full || interfaces.consolidator,
  'consolidator/asn-shipment': (interfaces) => interfaces.full || interfaces.consolidator,
  'consolidator/asn-receiving-list': (interfaces) => interfaces.full || interfaces.consolidator,
  'consolidator/asn-shipment-list': (interfaces) => interfaces.full || interfaces.consolidator,
};
